/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 观演人置顶操作
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/top/${id}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
